import { makeObservable } from 'mobx';
import NumeroProcessoUtil from '../../util/NumeroProcessoUtil';
import { Filtro } from './Filtro';

export default class FiltroRegiaoProcesso extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Região (TRT)';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return NumeroProcessoUtil.getObjetoNumeroProcesso(registro.processo.numeroCompleto).regional;
    }
}
